import { render } from "./DynamicDashboard.vue?vue&type=template&id=0039f6cd"
import script from "./DynamicDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/DynamicDash/DynamicDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0039f6cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0039f6cd', __exports__)) {
    api.reload('0039f6cd', __exports__)
  }
  
  module.hot.accept("./DynamicDashboard.vue?vue&type=template&id=0039f6cd", () => {
    api.rerender('0039f6cd', render)
  })

}


export default __exports__